var render, staticRenderFns
import script from "./TabItem.vue?vue&type=script&lang=js&"
export * from "./TabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Users/ben/Documents/GitHub/casa-padrino-theme/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ben/Documents/GitHub/casa-padrino-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6483e636')) {
      api.createRecord('6483e636', component.options)
    } else {
      api.reload('6483e636', component.options)
    }
    
  }
}
component.options.__file = "resources/js/src/app/components/common/TabItem.vue"
export default component.exports